module.exports = {"469029100":"保城镇","469029101":"什玲镇","469029102":"加茂镇","469029103":"响水镇","469029104":"新政镇","469029105":"三道镇","469029198":"县直辖村级区划","469029200":"六弓乡","469029201":"南林乡","469029202":"毛感乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469029.json
// module id = 2339
// module chunks = 0